import React, {Component} from "react"
import '../sass/elements/react-tags.scss';
import { withTranslation } from 'react-i18next';

class LabelsSelectorComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: '',
            showSuggestions: false,
            activeSuggestionIndex: -1
        };
        this.inputRef = React.createRef();
    }

    availableSuggestions() {
        return this.props.availableLabels.filter(label => 
            !this.props.selectedLabels.includes(label) &&
            label.toLowerCase().includes(this.state.inputValue.toLowerCase())
        );
    }

    handleInputFocus = () => {
        this.setState({ showSuggestions: true });
    }

    handleInputBlur = () => {
        // Delay hiding to allow click on suggestions
        setTimeout(() => {
            this.setState({ showSuggestions: false, activeSuggestionIndex: -1 });
        }, 200);
    }

    handleInputChange = (e) => {
        this.setState({ 
            inputValue: e.target.value,
            showSuggestions: true,
            activeSuggestionIndex: -1
        });
    }

    handleSuggestionClick = (suggestion) => {
        this.addLabel(suggestion);
    }

    handleKeyDown = (e) => {
        const suggestions = this.availableSuggestions();
        
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            this.setState(prev => ({
                activeSuggestionIndex: Math.min(prev.activeSuggestionIndex + 1, suggestions.length - 1)
            }));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            this.setState(prev => ({
                activeSuggestionIndex: Math.max(prev.activeSuggestionIndex - 1, -1)
            }));
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (this.state.activeSuggestionIndex >= 0 && suggestions[this.state.activeSuggestionIndex]) {
                this.addLabel(suggestions[this.state.activeSuggestionIndex]);
            } else if (this.state.inputValue.trim()) {
                this.addLabel(this.state.inputValue.trim());
            }
        } else if (e.key === 'Escape') {
            this.setState({ showSuggestions: false, activeSuggestionIndex: -1 });
        }
    }

    addLabel = (label) => {
        if (!this.props.selectedLabels.includes(label)) {
            this.props.onChangeSelection([...this.props.selectedLabels, label]);
        }
        this.setState({ inputValue: '', showSuggestions: false, activeSuggestionIndex: -1 });
        this.inputRef.current?.focus();
    }

    removeLabel = (labelToRemove) => {
        this.props.onChangeSelection(
            this.props.selectedLabels.filter(label => label !== labelToRemove)
        );
    }

    render() {
        const { t } = this.props;
        const { selectedLabels } = this.props;
        const suggestions = this.availableSuggestions();
        const { showSuggestions, activeSuggestionIndex, inputValue } = this.state;

        return (
            <div className="custom-tags-container">
                <div className="custom-tags-selected">
                    {selectedLabels.map((label, index) => (
                        <span key={index} className="custom-tag">
                            <span className="custom-tag-text">{label}</span>
                            <button 
                                type="button"
                                className="custom-tag-remove"
                                onClick={() => this.removeLabel(label)}
                                aria-label={`Remove ${label}`}
                            >
                                ×
                            </button>
                        </span>
                    ))}
                </div>
                
                <div className="custom-tags-input-container">
                    <input
                        ref={this.inputRef}
                        type="text"
                        className="custom-tags-input"
                        placeholder={t('labels_selector.add_label_placeholder')}
                        value={inputValue}
                        onChange={this.handleInputChange}
                        onFocus={this.handleInputFocus}
                        onBlur={this.handleInputBlur}
                        onKeyDown={this.handleKeyDown}
                    />
                    
                    {showSuggestions && suggestions.length > 0 && (
                        <ul className="custom-tags-suggestions">
                            {suggestions.map((suggestion, index) => (
                                <li
                                    key={index}
                                    className={`custom-tags-suggestion ${
                                        index === activeSuggestionIndex ? 'active' : ''
                                    }`}
                                    onClick={() => this.handleSuggestionClick(suggestion)}
                                >
                                    {suggestion}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        );
    }
}

export const LabelsSelector = withTranslation()(LabelsSelectorComponent);